/**
 * Tiny external store for the admin header verification-pending pill.
 * Keeps the count synchronised across components without a full context
 * provider. Updated from two sources:
 *   1. Initial fetch on admin login (`useUserNotifications`).
 *   2. WebSocket "verification_count_changed" events broadcast by the
 *      backend after every approve/reject/reset/bulk/resubmission.
 */
let count = null; // null = not loaded yet; 0+ = known value
const listeners = new Set();

export function setAdminPendingCount(n) {
    const next = typeof n === "number" && n >= 0 ? n : 0;
    if (next === count) return;
    count = next;
    listeners.forEach((l) => {
        try { l(); } catch (_) { /* ignore listener errors */ }
    });
}

export function resetAdminPendingCount() {
    if (count === null) return;
    count = null;
    listeners.forEach((l) => {
        try { l(); } catch (_) { /* ignore */ }
    });
}

export function getAdminPendingCount() {
    return count;
}

export function subscribeAdminPending(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
